import { parseDate } from '@internationalized/date';
import { DatePicker } from './untitled-ui/application/date-picker/date-picker';

interface Props { label?: string; value: string; onChange: (value: string) => void; isRequired?: boolean; name?: string; }
export function DateField({ label, value, onChange, isRequired, name }: Props) {
  let date = null;
  try { date = value ? parseDate(value.slice(0, 10)) : null; } catch { /* Empty or invalid API dates remain unselected. */ }
  return <div className="u-field u-date-field">{label && <span>{label}{isRequired && <em> *</em>}</span>}<DatePicker aria-label={label || 'Select date'} value={date} onChange={next => onChange(next?.toString() || '')} isRequired={isRequired} /><input type="hidden" name={name} value={value} /></div>;
}
